import type { UnderlyingHistorics } from 'components/shared/UnderlyingHistos/UnderlyingHistoModels';

export type UnderlyingHistoActions = UnderlyingHistoRequested | UnderlyingHistoFetched | UnderlyingHistoFetchFailed;
export function underlyingHistoRequested(bloombergIds: string[]) {
  return { type: 'UNDERLYING_HISTORICS_REQUESTED' as const, bloombergIds };
}

export type UnderlyingHistoRequested = ReturnType<typeof underlyingHistoRequested>;

export function underlyingHistoFetched(historics: UnderlyingHistorics) {
  return { type: 'UNDERLYING_HISTORICS_FETCHED' as const, historics };
}

export type UnderlyingHistoFetched = ReturnType<typeof underlyingHistoFetched>;

export function underlyingHistoFetchFailed(error?: string) {
  return { type: 'UNDERLYING_HISTORICS_FETCH_FAILED' as const, error };
}

export type UnderlyingHistoFetchFailed = ReturnType<typeof underlyingHistoFetchFailed>;
